import {join} from '@esgi/ui-kit/utils';
import React, {Component, TextareaHTMLAttributes} from 'react';
import {Selectors} from '../controls.selectors';

import styles from './textarea.module.less';

export type TextAreaProps = {
	autoResizeToFit?: boolean;
	hidePlaceholderOnFocus?: boolean;
	maxHeight?: number;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

export class TextArea extends Component<TextAreaProps> {
	public readonly inputRef: React.RefObject<HTMLTextAreaElement> = React.createRef<HTMLTextAreaElement>();

	public override componentDidMount() {
		if (this.inputRef.current) {
			this.recalculateSize();
			if (this.props.autoFocus) {
				this.inputRef.current.focus();
			}
		}
	}

	public override render() {
		const {
			autoResizeToFit,
			maxHeight,
			hidePlaceholderOnFocus,
			className,
			onChange,
			onFocus,
			onBlur,
			children,
			...props
		} = this.props;
		return <textarea data-cy={Selectors.TextArea}
		                 {...props}
		                 ref={this.inputRef}
		                 onChange={e => {
			                 onChange && onChange(e);
			                 this.recalculateSize(e);
		                 }}
		                 onFocus={(e) => {
			                 if (hidePlaceholderOnFocus) {
				                 e.target.placeholder = '';
			                 }
			                 onFocus && onFocus(e);
			                 this.recalculateSize(e);
		                 }}
		                 onBlur={(e) => {
			                 if (hidePlaceholderOnFocus) {
				                 e.target.placeholder = props.placeholder || '';
			                 }
			                 onBlur && onBlur(e);
			                 this.recalculateSize(e);
		                 }}
		                 className={join(styles.textArea, className)}/>;
	}

	public focus() {
		this.inputRef.current?.focus();
	}

	private recalculateSize = (e?: any) => {
		if (this.props.autoResizeToFit) {
			const text = this.inputRef.current;
			const borderOffset = 2;
			if (text) {
				text.style.height = 'auto';
				if (this.props.maxHeight) {
					if (text.scrollHeight <= this.props.maxHeight) {
						text.style.height = text.scrollHeight + borderOffset + 'px';
					} else {
						text.style.height = this.props.maxHeight + borderOffset + 'px';
					}
				} else {
					text.style.height = text.scrollHeight + 'px';
				}
			}
		}
	};
}

export default TextArea;
